import { render, staticRenderFns } from "./restaurant-dashboard.vue?vue&type=template&id=02c46052&"
import script from "./restaurant-dashboard.vue?vue&type=script&lang=js&"
export * from "./restaurant-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports